export const isMobile = () =>  (/iphone|ipod|android|ie|blackberry|fennec/).test(navigator.userAgent.toLowerCase());
